const module = { name: 'focusableInput/error', exports: {} }; const exports = module.exports;



const Selectors = {
    ERROR: '.js-fcsbl-input-error',
    ERROR_MSG: '.js-fcsbl-input-error-msg',
    INPUT: '.js-fcsbl-input',
    LABEL: '.js-fcsbl-label',
    PASSWORD_TOGGLE: '.js-fcsbl-pw-toggle',
}


const Styles = {
    ERROR: 'fcsbl-input__error',
    HIDE: 'hide',
}
function toggleErrors(fields, show) {
    fields.forEach(({ $input, error }) => toggle($input, error, show));
}
function toggle($input, error, show) {
    const $errorElement = $input.siblings(Selectors.ERROR);
    $input.siblings(Selectors.PASSWORD_TOGGLE).toggleClass(Styles.HIDE, show);
    $errorElement.children(Selectors.ERROR_MSG).text(error || '');
    $errorElement.toggleClass(Styles.HIDE, !show);
    $input.siblings(Selectors.LABEL).toggleClass(Styles.ERROR, show);
    $input.toggleClass(Styles.ERROR, show);
}
module.exports = {
    toggle,
    toggleErrors
};
export default module.exports;